import Axios from 'axios'
import store from '../store'

export default {
  tenantId: () => store.getters['Client/clientId'],
  sendChatMessage(payload) {
    return Axios.post(`api/v1/${this.tenantId()}/chat/messages`, payload, {
      ignoreGlobalCatch: true,
    })
  }
}
